import { Phone as PhoneIcon } from "lucide-react";
import { BRAND } from "@/lib/design";

export default function EmergencyBanner() {
    return (
        <section
            className="py-6 bg-gradient-to-r from-[#C8A24A]/20 via-[#C8A24A]/10 to-[#C8A24A]/20 border-y border-[#C8A24A]/30"
            data-testid="emergency-placement-banner"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 flex items-center justify-center gap-4 text-center">
                <span className="relative flex h-3 w-3 shrink-0">
                    <span className="absolute inline-flex h-full w-full rounded-full bg-[#C8A24A] opacity-75 animate-ping" />
                    <span className="relative inline-flex h-3 w-3 rounded-full bg-[#C8A24A]" />
                </span>
                <p className="font-[Outfit] text-[15px] md:text-[17px] font-semibold tracking-tight text-[#8a6b1f]">
                    Now Accepting Temporary Emergency Placements
                </p>
                <span className="hidden md:inline text-[#8a6b1f]/40">·</span>
                <a
                    href={BRAND.phoneHref}
                    className="hidden md:inline-flex items-center gap-1.5 text-[15px] font-bold text-[#C8A24A] hover:text-[#a98835] transition-colors"
                    data-testid="emergency-phone-link"
                >
                    <PhoneIcon className="h-3.5 w-3.5" />
                    {BRAND.phone}
                </a>
            </div>
        </section>
    );
}
